import { IRootScopeService, IWindowService } from 'angular';

export function locationChangeConfigRun( $rootScope: IRootScopeService, $window: IWindowService ) {
  $rootScope.$on('$locationChangeSuccess', () => {
    $window.scrollTo(0, 0);
  });
}

locationChangeConfigRun.$inject = [
  '$rootScope',
  '$window'
];



// WEBPACK FOOTER //
// ./app/run/location-change-config.run.ts